var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _circle, _ellipse, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#B05FFD",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7B2CBF",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 120,
    width: 140,
    height: 280,
    rx: 5,
    fill: "url(#grad3)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 145,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 145,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 145,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 185,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 185,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 185,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 225,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 225,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 225,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 265,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 265,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 265,
    width: 25,
    height: 25,
    rx: 3,
    fill: "white",
    opacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 340,
    width: 40,
    height: 60,
    rx: 3,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 220,
    width: 90,
    height: 180,
    rx: 5,
    fill: "#c0c0c0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 240,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 240,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 275,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 275,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 310,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 310,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 355,
    width: 30,
    height: 45,
    rx: 2,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 180,
    width: 90,
    height: 220,
    rx: 5,
    fill: "#e0e0e0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 200,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 200,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 235,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 235,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 270,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 270,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 305,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 385,
    y: 305,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    opacity: 0.7
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 350,
    width: 30,
    height: 50,
    rx: 2,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 400,
    width: 400,
    height: 10,
    rx: 5,
    fill: "#e0e0e0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 90,
    r: 25,
    fill: "none",
    stroke: "url(#grad3)",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 90,
    rx: 25,
    ry: 10,
    fill: "none",
    stroke: "url(#grad3)",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 65,
    x2: 250,
    y2: 115,
    stroke: "url(#grad3)",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.d0ef060e2bcbd2486f9c0c81466dd9b2.svg";
export { ForwardRef as ReactComponent };